import CoreLayout from "components/layout";
import PageError from "components/routes/pageError";
import PublicRoute from "components/routes/publicRoute";
import CourseInfo from "pages/CourseInfo";
import CourseInfoBranch from "pages/CourseInfoBranch";
import Home from "pages/Home";
import Questions from "pages/Questions";

import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import {
  defaultAcademicYear,
  hasAcademicYearContent,
  resolveAcademicBeYear,
} from "years";
import "./App.less";

import Cooperative from "pages/Cooperative";
import Enrollment from "pages/Enrollment";
import LeaveCondition from "pages/LeaveCondition";
import Registration from "pages/Registration";
import ServiceSUT from "pages/ServiceSUT";

const departmentComponentContext = require.context(
  "./pages/Department",
  true,
  /^\.\/\d{4}\/(Agricultural|Degitech|Dentistry|Engineering|Medicine|Nursing|PublicHealth|Science|Social)\/index\.jsx$/
);

const departmentFolders = {
  "department-science": "Science",
  "department-social": "Social",
  "department-agricultural": "Agricultural",
  "department-engineering": "Engineering",
  "department-medicine": "Medicine",
  "department-nursing": "Nursing",
  "department-dentistry": "Dentistry",
  "department-public-health": "PublicHealth",
  "department-degitech": "Degitech",
};

const departmentRoutes = Object.keys(departmentFolders);

function getDepartmentComponent(year, departmentSlug) {
  const folder = departmentFolders[departmentSlug];
  const selectedBeYear = resolveAcademicBeYear(year);
  const componentKeys = departmentComponentContext.keys();
  const preferredKey = `./${selectedBeYear}/${folder}/index.jsx`;
  const fallbackKeys = [
    preferredKey,
    `./2568/${folder}/index.jsx`,
    `./2567/${folder}/index.jsx`,
  ];
  const componentKey =
    hasAcademicYearContent(year) && componentKeys.includes(preferredKey)
      ? preferredKey
      : fallbackKeys.find((key) => componentKeys.includes(key));

  if (!componentKey) return null;

  const module = departmentComponentContext(componentKey);
  return module.default || module;
}

function DepartmentRoute({ departmentSlug, selectYear, year }) {
  const DepartmentComponent = getDepartmentComponent(year, departmentSlug);

  if (!DepartmentComponent) return <PageError />;

  return <DepartmentComponent selectYear={selectYear} year={year} />;
}

function App() {
  const [year, setYear] = useState(
    localStorage.getItem("year") || defaultAcademicYear.ce
  );

  useEffect(() => {
    const yearItem = localStorage.getItem("year");
    if (yearItem != null && year !== yearItem) {
      setYear(yearItem);
    }
  }, [year]);

  const selectYear = (value) => {
    localStorage.setItem("year", value);
    setYear(value);
  };

  return (
    <Routes>
      <Route path="/" element={<CoreLayout />}>
        <Route element={<PublicRoute />}>
          <Route
            path="/"
            element={<Home selectYear={selectYear} year={year} />}
          />
          <Route
            path="/course-introduction"
            element={<CourseInfo year={year} />}
          />

          {departmentRoutes.map((departmentSlug) => (
            <Route
              key={departmentSlug}
              path={`/course-introduction/${departmentSlug}`}
              element={
                <DepartmentRoute
                  departmentSlug={departmentSlug}
                  selectYear={selectYear}
                  year={year}
                />
              }
            />
          ))}

          {/* <Route
            path='/course-introduction/:group'
            element={<CourseInfoGroup />}
          /> */}
          <Route
            path="/course-introduction/:group/:branch"
            element={<CourseInfoBranch year={year} />}
          />
          <Route path="/enrollment" element={<Enrollment year={year} />} />
          <Route
            path="/enrollment/:type"
            element={<Registration year={year} />}
          />

          <Route
            path="/leave-conditions"
            element={<LeaveCondition year={year} />}
          />
          <Route
            path="/contact-cooperative-education"
            element={<Cooperative year={year} />}
          />
          <Route
            path="/university-service"
            element={<ServiceSUT year={year} />}
          />
          <Route path="/questions" element={<Questions year={year} />} />
        </Route>

        <Route path="*" element={<PageError />} />
      </Route>
    </Routes>
  );
}

export default App;
